import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import { Authentication } from 'src/helpers/Authorization';
import Permission from "src/helpers/Permission";
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContextProvider } from 'react-dnd';

const HeThong = asyncComponent(() => import('./HeThong'));
const ThongKe = asyncComponent(() => import('./ThongKe'));
const DanhMuc = asyncComponent(() => import('./DanhMuc'));
const BaoCao = asyncComponent(() => import('./BaoCao'));
const HoSo = asyncComponent(() => import('./User/HoSo'));
const Error401 = asyncComponent(() => import('./CustomViews/401'));
const Home = asyncComponent(() => import('./User/Home'));
export class App extends PureComponent {
  render() {
    const { match, activedVaiTro } = this.props;
    /**
     * Bỏ comment activedVaiTro
     * Đoạn này sử dụng như KHCN
     * Tiến hành extract danh sách activedVaiTro ra dựa theo danh sách trả về mà làm việc
     * Vẫn chưa thể động hoàn toàn
     * Cần bổ sung khai báo component được sử dụng cho vai trò đó mới có thể làm được
     * Nan giải
     * */
    return (
      <div className="gx-main-content-wrapper">
        <DragDropContextProvider backend={HTML5Backend}>
          <Switch>
            <Route path={`${match.url}he-thong`} component={Authentication(HeThong, activedVaiTro, [Permission.ADMIN, Permission.DM_QTHT], true)} />
            <Route path={`${match.url}danh-muc`} component={Authentication(DanhMuc, activedVaiTro, [Permission.ADMIN, Permission.DM_ALL], true)} />
            <Route path={`${match.url}bao-cao`} component={Authentication(BaoCao, activedVaiTro, [Permission.ADMIN, Permission.BC_ALL], true)} />
            <Route path={`${match.url}thong-ke`} component={Authentication(ThongKe, activedVaiTro, [Permission.ADMIN, Permission.TK_ALL], true)} />
            <Route path={`${match.url}error/401`} component={Authentication(Error401, activedVaiTro, [Permission.ADMIN], true)} />
            <Route path={`${match.url}user/ho-so`} component={HoSo} />
            <Route path={`${match.url}user/home`} component={Home} />
          </Switch>
        </DragDropContextProvider>
      </div>
    );
  }
}

export default App;
